import { useEffect, useState } from 'react';

/**
 * True while a list that is still empty may be about to fill: from when `key` changes (a new space or channel) until
 * data arrives (`empty` turns false) or `maxMs` passes, whichever comes first. After that an empty list is truly empty
 * and the real empty state shows. Used for lists that have no "finished loading" signal of their own.
 */
export function useLoadingHold(empty: boolean, key: string, maxMs = 1500): boolean {
  const [expired, setExpired] = useState(false);
  useEffect(() => {
    setExpired(false);
    const t = window.setTimeout(() => setExpired(true), maxMs);
    return () => window.clearTimeout(t);
  }, [key, maxMs]);
  return empty && !!key && !expired;
}
